import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {GetForingLang, GetInterfaceLang, GetOneLearningLanguage, getGrammarPage, DelRule, getDetailRule, GetAllLanguage, GetGrammarStat, getRuleFilter} from '../../actions/index';

class Vocabulary extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.addRule = this.addRule.bind(this);
        this.renderTooltip = this.renderTooltip.bind(this);
        this.renderWord = this.renderWord.bind(this);
        this.editRule = this.editRule.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.delRule = this.delRule.bind(this);
        this.delRuleOpenModal = this.delRuleOpenModal.bind(this);
        this.renderIcon = this.renderIcon.bind(this);
        this.filterInput = this.filterInput.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetForingLang(token);
        this.props.GetInterfaceLang(token);
        this.props.GetAllLanguage(token);
        this.props.getGrammarPage(token, this.props.params.id);
        this.props.GetGrammarStat(this.props.params.id);
        this.props.GetOneLearningLanguage(this.props.params.id, token);
    }
    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
        $('.selectpicker').selectpicker();
    }
    componentWillUnmount(){
        this.props.lang.words = {}
    }
    addRule(){
        this.context.router.push('/language/learning/edit/'+this.props.params.id+'/grammar_page/add');
    }
    editRule(id, item){
        this.context.router.push('/language/learning/edit/'+this.props.params.id+'/grammar_page/edit/'+id+'/');
    }
    delRule(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DelRule(token, this.props.lang.rule_detail.id).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                $('input[name="word"]').val('')
                this.props.getGrammarPage(token, this.props.params.id);
            }
        });
    }
    delRuleOpenModal(id, flang, item){
        let token = localStorage.getItem('id_token_admin');
        let that= this;
        $('#DelWord').modal('show');
        $('#DelWord').on('shown.bs.modal', function () {
            that.props.getDetailRule(id, token, flang);
        });
    }
    closeModal(){
        $('#DelWord').modal('hide');
    }
    renderIcon(item){
        return item.map((code)=>{
            if(code.content != '<p><br></p>' && code.content != '') {
                return this.props.lang.interface_lang.results.map((lang) => {
                    if(lang.id == code.blang){
                        return <i>{lang.lang.code}</i>
                    }
                });
            }
        });
    }
    renderSelectFilter(id){
        this.props.lang.interface_lang.results.forEach((item)=>{
            if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
                return false
            }else{
                if($('#'+id).find('option#'+item.id).length){
                    return false
                }else{
                    $('#'+id).append($('<option>', {
                        value: item.id,
                        text : item.lang.name,
                        id : item.id
                    }));
                }
            }
        });
        $('.selectpicker').selectpicker('refresh');
    }
    renderWord(){
        return this.props.lang.grammar.results.map((item, i)=>{
            return (
                <div className="white-block common-list two clearfix" key={item.id}>
                    <p>{i+1}</p>
                    <p className="common-item-with-tag">
                        <span onClick={this.editRule.bind(this, item.id)}>{item.name}</span>
                        {this.props.lang.interface_lang ? this.renderIcon(item.translations) : ""}
                    </p>
                    <p className="pull-right">
                        <button type="button" onClick={this.editRule.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true"></span>
                        </button>
                        <button type="button" onClick={this.delRuleOpenModal.bind(this, item.id, item.flang)}>
                            <span className="span glyphicon glyphicon-trash"></span>
                        </button>
                    </p>
                </div>
            )
        })
    }
    renderTooltip(){
        return this.props.lang.interface_lang.results.map((item)=>{
            if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
                return false
            }else{
                return this.props.lang.grammar_stat.map((stat)=>{
                    if(item.id == stat.blang){
                        let string = stat.translated+ ' / ' +stat.total;
                        return(
                            <p key={item.id} className="pull-left info-item" data-toggle="tooltip" data-placement="top" title={string} >{item.lang.name}</p>
                        )
                    }
                })
            }
        })
    }
    filterInput(e){
        if(e.target.name == 'woblang'){
            $('select[name="wblang"]').val('selectDefault')
        }
        if(e.target.name == 'wblang'){
            $('select[name="woblang"]').val('selectDefault')
        }
        let token = localStorage.getItem('id_token_admin');
        let data = {

            flangs: $('input[name="flangs"]').val(),
            name: $('input[name="word"]').val(),
            woblang: $('select[name="woblang"]').val() != 'selectDefault' ? $('select[name="woblang"]').val() : '',
            wblang: $('select[name="wblang"]').val() != 'selectDefault' ? $('select[name="wblang"]').val() : ''
        }
        this.props.getRuleFilter(token, data);
        $('.selectpicker').selectpicker('refresh');
    }
    render() {
        return (
            <div>
                <div className="dashboard-wrapper">
                    <div className="dashboard-title clearfix">
                        <div className="pull-left">
                            <p className="dashboard-title">Grammar page</p>
                            <p className="dashboard-text">{this.props.lang.learning_lang_one.lang ? this.props.lang.learning_lang_one.lang.name : "" }</p>
                        </div>
                        <button onClick={this.addRule} type="button" className="pull-right btn btn-primary">
                            <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                            Add rule
                        </button>
                    </div>
                    <div>
                        <div className="col-md-12">
                            <div className="white-block">
                                <div className="clearfix static-header-buttons">
                                    <p className="pull-left">Translate to</p>
                                    <div className="block-info-group">
                                        {this.props.lang.foring_lang.results && this.props.lang.learning_lang_one.lang ? this.renderTooltip() : ""}
                                    </div>
                                </div>
                                <div className="separate-horizontal"> </div>
                                <div className="clearfix">
                                    <input type="text" name="flangs" value={this.props.params.id} hidden="hidden" onChange={this.filterInput}/>
                                    <div className="col-md-6">
                                        <div className=" input-group search_block">
                                            <span className="input-group-addon glyphicon glyphicon-search"></span>
                                            <input type="search" name="word" className="form-control" placeholder="Search" onChange={this.filterInput}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-half pull-left mr20">
                                            <select className="selectpicker" name="woblang" id="Without" defaultValue="selectDefault" data-live-search="true" onChange={this.filterInput}>
                                                <option value="selectDefault">Without translation into</option>
                                                {this.props.lang.foring_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.interface_lang.results ? this.renderSelectFilter('Without') : ""}
                                            </select>
                                        </div>
                                        <div className="input-half pull-left">
                                            <select className="selectpicker" name="wblang" id="into" defaultValue="selectDefault" data-live-search="true" onChange={this.filterInput}>
                                                <option value="selectDefault">Translated into</option>
                                                {this.props.lang.foring_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.interface_lang.results ? this.renderSelectFilter('into') : ""}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.lang.grammar.results && this.props.lang.grammar.results.length > 0 ?
                            <div>
                                <div className="col-md-12">
                                    <div className="common-list two clearfix">
                                        <p>#</p>
                                        <p>Name rule</p>
                                        <p className="pull-right">Option</p>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    {this.renderWord() }
                                </div>
                            </div>
                            :
                            <div className={this.props.lang.grammar.results && this.props.lang.grammar.results.length< 0 || $.isEmptyObject(this.props.lang.grammar) ? "for_preloader" : 'for_preloader dn'}>
                                <div className="preloader-wrapper big active">
                                    <div className="spinner-layer spinner-blue-only">
                                        <div className="circle-clipper left">
                                            <div className="circle" />
                                        </div>
                                        <div className="gap-patch">
                                            <div className="circle" />
                                        </div>
                                        <div className="circle-clipper right">
                                            <div className="circle" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.props.lang.grammar.results && this.props.lang.grammar.results.length === 0 && <p className="noResults">No items result</p>}
                    </div>

                    <div className="modal fade" id="DelWord" tabIndex="-1" role="dialog" aria-labelledby="DelWordLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body text-center">
                                    <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelWord"></span>
                                    <p>Do you really want to delete this rule {this.props.lang.rule_detail ? <span>{this.props.lang.rule_detail.name}</span> : ""}?</p>
                                </div>
                                <div className="modal-footer text-center">
                                    <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                    <button onClick={this.delRule} type="button" className="btn btn-primary">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        lang: state.lang
    }
}
export default connect(mapStateToProps, {GetForingLang, GetInterfaceLang, GetOneLearningLanguage, getGrammarPage, DelRule, getDetailRule, GetAllLanguage, GetGrammarStat, getRuleFilter})(Vocabulary);


// WEBPACK FOOTER //
// ./src/components/language/grammar.js